const ALL_API = { // 微信公众号通过code换取网页授权access_token
  getUserInfoByCode: {
    method: 'get',
    url: '/api/weChat/getUserInfo'
  },
  getOpenIdByCode: {
    method: 'get',
    url: '/api/weChat/getOpenIdByCode'
  },
  getUserInfo: {
    method: 'get',
    url: '/api/wechat/getUserInfo'
  },
  sendSmsCode: { // 发送验证码
    method: 'post',
    url: '/api/wechat/sendSmsCode'
  },
  memberRegister: { // 注册
    method: 'post',
    url: '/api/wechat/memberRegister'
  },
  getSignPackage: { // 生成签名
    method: 'post',
    url: '/api/wechat/getSignPackage'
  },
  // 获取总部配置 - 注册时是否需要短信验证
  getCommonConfig: {
    method: 'get',
    url: '/api/wechat/getParameterConfig?version_type=1&system_type=1&operate_type=34'
  }
}

export default ALL_API



// WEBPACK FOOTER //
// ./src/api/wechat/index.js